import { createSelector } from 'reselect'
import { getCurrentUserSelector } from './app'

// PLOP_APPEND_PATTERN_ANCHOR

export const choicesGeolocationsSelector = createSelector(
  ({ choices }) => choices.geolocations.items,
  items => items
)

export const choicesGeolocationsLoadingSelector = createSelector(
  ({ choices }) => choices.geolocations.isLoading,
  isLoading => isLoading
)

export const choicesCountriesSelector = createSelector(
  ({ choices }) => choices.countries.results,
  results => results
)

export const currentUserCountrySelector = createSelector(
  getCurrentUserSelector,
  ({ choices }) => choices.countries.results,
  (currentUser, countries) => countries.find(country => country.id === currentUser.country)
)

export const choicesCountriesLoadingSelector = createSelector(
  ({ choices }) => choices.countries.isLoading,
  isLoading => isLoading
)

export const choicesCountriesWasLoadedSelector = createSelector(
  ({ choices }) => choices.countries.wasLoaded,
  wasLoaded => wasLoaded
)

export const choicesInterestsSelector = createSelector(
  ({ choices }) => choices.interests.items,
  items => items
)

export const choicesInterestsLoadingSelector = createSelector(
  ({ choices }) => choices.interests.isLoading,
  isLoading => isLoading
)

export const choicesLanguagesSelector = createSelector(
  ({ choices }) => choices.languages.results,
  results => results
)

export const choicesLanguagesLoadingSelector = createSelector(
  ({ choices }) => choices.languages.isLoading,
  isLoading => isLoading
)

export const choicesLanguagesWasLoadedSelector = createSelector(
  ({ choices }) => choices.languages.wasLoaded,
  wasLoaded => wasLoaded
)

export const choicesPixelsSelector = createSelector(
  ({ choices }) => choices.pixels.results,
  results => results
)

export const choicesPixelsLoadingSelector = createSelector(
  ({ choices }) => choices.pixels.isLoading,
  isLoading => isLoading
)

export const choicesPixelsWasLoadedSelector = createSelector(
  ({ choices }) => choices.pixels.wasLoaded,
  wasLoaded => wasLoaded
)

export const choicesCTASelector = createSelector(
  ({ choices }) => choices.cta.results,
  results => results
)

export const choicesCTAByGoalSelector = goal => {
  return createSelector(
    ({ choices }) => choices.ctaByGoal[goal]?.results,
    results => results || []
  )
}

export const choicesCTAWasLoadedSelector = createSelector(
  ({ choices }) => choices.cta.wasLoaded,
  wasLoaded => wasLoaded
)

export const choicesCTAByGoalWasLoadedSelector = goal => {
  return createSelector(
    ({ choices }) => choices.ctaByGoal[goal]?.wasLoaded,
    wasLoaded => wasLoaded
  )
}

export const choicesActionsSelector = createSelector(
  ({ choices }) => choices.actions.results,
  results => results
)

export const choicesActionsWasLoadedSelector = createSelector(
  ({ choices }) => choices.actions.wasLoaded,
  wasLoaded => wasLoaded
)

export const choicesAllocationUnitsSelector = createSelector(
  ({ choices }) => choices.allocationUnits.results,
  results => results
)

export const choicesAllocationUnitsIsLoadingSelector = createSelector(
  ({ choices }) => choices.allocationUnits.isLoading,
  isLoading => isLoading
)

export const choicesAllocationUnitsWasLoadedSelector = createSelector(
  ({ choices }) => choices.allocationUnits.wasLoaded,
  wasLoaded => wasLoaded
)

// Get facebook client apps
export const facebookClientAppsSelector = createSelector(
  ({ choices }) => choices.facebookClientApps.results,
  results => results
)

export const getFacebookClientAppsIsLoadingSelector = createSelector(
  ({ choices }) => choices.facebookClientApps.isLoading,
  isLoading => isLoading
)

export const getFacebookClientAppsWasLoadedSelector = createSelector(
  ({ choices }) => choices.facebookClientApps.wasLoaded,
  wasLoaded => wasLoaded
)

export const getFacebookClientAppsErrorSelector = createSelector(
  ({ choices }) => choices.facebookClientApps.error,
  error => error
)

export const facebookClientAppsWasLoadedSelector = createSelector(
  ({ choices }) => choices.facebookClientApps.wasLoaded,
  wasLoaded => wasLoaded
)

// Get choices behaviours
export const choicesBehavioursSelector = createSelector(
  ({ choices }) => choices.choicesBehaviours.results,
  results => results
)

export const getChoicesBehavioursIsLoadingSelector = createSelector(
  ({ choices }) => choices.choicesBehaviours.isLoading,
  isLoading => isLoading
)

export const getChoicesBehavioursErrorSelector = createSelector(
  ({ choices }) => choices.choicesBehaviours.error,
  error => error
)

export const choicesBehavioursWasLoadedSelector = createSelector(
  ({ choices }) => choices.choicesBehaviours.wasLoaded,
  wasLoaded => wasLoaded
)

// Get custom conversions
export const customConversionsSelector = createSelector(
  ({ choices }) => choices.customConversions.results,
  results => results
)

export const getCustomConversionsIsLoadingSelector = createSelector(
  ({ choices }) => choices.customConversions.isLoading,
  isLoading => isLoading
)

export const getCustomConversionsErrorSelector = createSelector(
  ({ choices }) => choices.customConversions.error,
  error => error
)

export const customConversionsWasLoadedSelector = createSelector(
  ({ choices }) => choices.customConversions.wasLoaded,
  wasLoaded => wasLoaded
)
